<template>
<div>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">
                {{ placement_group_data.name }} Statistics 
                <router-link :to="{ name: 'new_statistics', query: {data: placement_group_data.id} }" class="btn btn-tool"><i class="fa fa-plus"></i></router-link>
            </h3>

            <div class="card-tools">
                <button class="btn btn-tool" @click.prevent="loadStatistics(placement_group_data.id)"><i :class="{'fa-spin': isLoading}" class="fas fa-sync" aria-hidden="true"></i></button>
                <button class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i></button>
            </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body table-responsive p-0">
            <div class="col-md-12">
                <div class="col-md-3 float-left">
                    <label>Date range:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="far fa-calendar-alt"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control float-right" id="daterange">
                    </div>
                </div>
                <div class="col-md-1 col-xs-3 float-left">
                    <div class="form-group">
                        <label for="entries">Limit:</label>
                        <select class="form-control" v-model="query.limit">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option selected value="30">30</option>
                            <option value="60">60</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-1 col-xs-3 float-left">
                    <div class="form-group">
                        <label for="entries">Order:</label>
                        <select class="form-control" v-model="query.order">
                            <option value="date">Oldest</option>
                            <option value="-date" selected="">Newest</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-1 col-xs-12 float-left">
                    <hr style="visibility: hidden;">
                    <button class="btn btn-primary" @click.prevent="loadStatistics(placement_group_data.id)"><i class="fa fa-search"></i></button>
                </div>
            </div>

        <table class="table table-hover">
            <thead>
            <tr>
                <th class="text-center">Date</th>
                <th class="text-center" v-for="metric in metrics" :key="metric"> {{ metric | capitalizeAndReplace }} </th>
                <th class="text-center">Status</th>
                <th class="text-center">Complete</th>
                <th class="text-center">Update At</th>
                <th class="text-center">Action</th>
            </tr>
            </thead>
            <tbody>
                <tr v-if="statistics.length <= 0">
                    <td :colspan="metrics.length+5" class="text-center">
                        <span v-if="!isLoading">No statistics available</span>
                        <span v-if="isLoading"><i class="fa fa-spinner fa-3x fa-pulse"></i></span>
                    </td>
                </tr>
                <tr v-for="statistic in statistics" :key="statistic.id" v-animate-css="'slideInLeft'">
                    <td class="text-center">{{ statistic.date }}</td>
                    <td class="text-center" v-for="metric in metrics" :key="metric"> {{ signs[metric] }}{{ statistic[metric] }} </td>
                    <td class="text-center">
                        <strong :class="statistic.status === 'active'? 'text-success' : 'text-danger'">
                            {{ statistic.status | capitalize }}
                        </strong>
                    </td>
                    <td class="text-center">
                        <i class="fa x-large" 
                            :class="{'fa-check-circle text-success': statistic.complete, 
                                        'fa-info-circle text-warning': !statistic.complete}"
                            data-toggle="tooltip" data-placement="top"
                            :title="statistic.complete? 'Completed' : 'Unfinished'"
                        >
                        </i>
                    </td>
                    <td class="text-center">{{ statistic.modified_at | formatDate}}</td>

                    <td class="text-center">
                        <div class="btn-group btn-group-sm">
                            <button class="btn btn-default" @click.prevent="loadStatistic(statistic.id)"><i class="fa fa-edit"></i> Edit</button>
                            <button class="btn btn-danger"><i class="fa fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
            <ul class="pagination pagination-sm m-0 float-right">
                <li class="page-item">
                    <a class="page-link" href="#" @click.prevent="previousPage">Previous</a>
                </li>
                <li class="page-item">
                    <a class="page-link">{{ currentPage }} / {{ pageCount }}</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#" @click.prevent="nextPage">Next</a>
                </li>
            </ul>
        </div>
    </div>
    <!-- /.card -->

    <StatisticsModel
        v-if="placement_group_data"
        :statistic="statistic"
        :data_id="placement_group_data.id"
        :show="showStatisticsModel"
        :reloading="reloadingStatistic"
        @close="StatisticsModelClosed"
        @reload="reloadStatistic" 
    />

</div>
</template>

<script>
import StatisticsModel from '@/components/statistics/data/Model'

import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory'
const SystemRepo = RepositoryFactory.get('system')
const StatisticsRepo = RepositoryFactory.get('statistics')
const PlacementsGroupsDataRepo = RepositoryFactory.get('groups_data')

export default {
    components: {
        StatisticsModel
    },
    data() {
        return {
            metrics: [],
            signs: {},

            statistics: [],
            statistic: {},
            showStatisticsModel: false,

            placement_group_data: {},
            query: {
                start_date: "",
                end_date: "",
                limit: 30,
                order: "-date"
            },

            currentPage: 1,
            totalRecords: 0,
            isLoading: false,
            reloadingStatistic: false,
        }
    },
    created() {
        this.loadSystemMetrics()
    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip()
    },
    mounted() {
        //Date range as a button
        var self = this
        $('#daterange').daterangepicker({
            ranges   : {
            'Today'       : [moment(), moment()],
            'Yesterday'   : [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days' : [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month'  : [moment().startOf('month'), moment().endOf('month')],
            'Last Month'  : [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            startDate: moment().subtract(29, 'days'),
            endDate  : moment()
            },
            function (start, end) {
                self.query.start_date = start.format('YYYY-MM-DD')
                self.query.end_date = end.format('YYYY-MM-DD')
            }
        )
    },
    methods: {
        loadSystemMetrics: function() {
            SystemRepo.metrics().then(result => {
                this.metrics = result.data.display
                this.signs = result.data.signs
            }).catch(err => {})
        },
        loadPlacementGroupData: function(id) {
            this.isLoaded = false
            PlacementsGroupsDataRepo.get(id).then(result => {
                this.placement_group_data = result.data
            }).catch(err => {})
        },
        loadStatistics: function(id) {
            this.isLoading = true
            this.statistics = []
            StatisticsRepo.page(id, this.currentPage, this.query.limit,
                                this.query.start_date, this.query.end_date, "", this.query.order).then(result => {
                this.totalRecords = result.data.count
                this.statistics = result.data.results
                this.isLoading = false
            }).catch(err => {
                this.isLoading = false
            })
        },
        loadStatistic(id) {
            StatisticsRepo.get(id).then(result => {
                this.statistic = result.data
                this.showStatisticsModel = true
            }).catch(err => {})
        },
        reloadStatistic(statistic_id) {
            this.reloadingStatistic = true
            StatisticsRepo.get(statistic_id).then(result => {
                this.statistic = result.data
                this.reloadingStatistic = false
            }).catch(err => {
                this.reloadingStatistic = false
            })
        },
        StatisticsModelClosed() {
            this.showStatisticsModel = false
            this.statistic = {}
        },
        nextPage: function() {
            if(this.currentPage != this.pageCount || this.currentPage > this.pageCount) {
                this.currentPage = this.currentPage + 1
                this.loadStatistics(this.placement_group_data.id)
            }
        },
        previousPage: function() {
            if(this.currentPage != 1 ) {
                this.currentPage = this.currentPage - 1
                this.loadStatistics(this.placement_group_data.id)
            }
        },
    },
    computed: {
        pageCount: function() {
            return Math.ceil(this.totalRecords / this.query.limit)
        },
    },
    watch: {
        '$route.params.id': {
            handler: function (id) {
                if(typeof id !== 'undefined') {
                    this.loadPlacementGroupData(id)
                    this.loadStatistics(id)
                }
            },
            deep: true,
            immediate: true
        },
    }
}
</script>
<style scoped>
.x-large {
    font-size: x-large;
}
</style>